import { ICellRendererParams } from 'ag-grid-community';

import { IEmployee } from 'contacts/types';
import { ExpandableList } from 'core/components';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Email, TextLine } from 'core/elements';

export const EmployeeCell = ({ value }: ICellRendererParams) => {
  if (!value || !value?.length) {
    return DEFAULT_PLACEHOLDER;
  }

  return (
    <ExpandableList<IEmployee>
      items={value as IEmployee[]}
      itemRenderer={(employee: IEmployee) => (
        <>
          <TextLine text={`${employee.employeeName} [${employee.employeeId}]`} textEllipsis />

          <TextLine text={<Email email={employee.email} />} isSubText textEllipsis />
        </>
      )}
      getItemKey={(employee: IEmployee) => employee.employeeId}
      maxItems={2}
    />
  );
};
